import tw from 'tailwind-styled-components'

export const AgendaLegendContainer = tw.div`
    flex
    gap-2
`
